var INIT = 'INIT';
var SET_FORM = 'SET_FORM';
var INITMENU = 'INITMENU';
var USERINFO = 'USERINFO';
var CHANGESUBMENU = 'CHANGESUBMENU';
var CHANGEITEM = 'CHANGEITEM';
var CRUMBINFO = 'CRUMBINFO';
var RESET_START = 'RESET_START';
var RESET = 'RESET';
var CHANGELOGIN = 'CHANGELOGIN';
var CHANGELOGINOUT = 'CHANGELOGINOUT';
var CHANGECARTNUM = 'CHANGECARTNUM';
var CHANGEACTIVITY = 'CHANGEACTIVITY';
var CHANGEBUSINESS = 'CHANGEBUSINESS';
var CHANGEISONETHINGYARD = 'CHANGEISONETHINGYARD';
var setCurrentMenuCrumbs = 'setCurrentMenuCrumbs';
export { SET_FORM, INIT, INITMENU, USERINFO, CHANGESUBMENU, CHANGEITEM, CRUMBINFO, RESET_START, RESET, CHANGELOGIN, CHANGELOGINOUT, CHANGECARTNUM, CHANGEACTIVITY, CHANGEBUSINESS, CHANGEISONETHINGYARD, setCurrentMenuCrumbs };